/**
 * Client-side plugin that fetches the CSRF token on app boot.
 *
 * This async plugin runs before the app mounts, guaranteeing that csrfToken.value
 * is populated before any component makes a CSR request.
 *
 * The token is stored in useState('csrf-token') so it can be read by useGraphQL.ts
 * and sent to the server via the X-CSRF-Token header.
 *
 * Why async plugin?
 * - Nuxt awaits async plugins before mounting the app
 * - Ensures all components have a valid CSRF token before rendering
 * - Eliminates race conditions on page load
 */
export default defineNuxtPlugin(async () => {
    const csrfToken = useState<string>('csrf-token')

    try {
        const response = await $fetch<{ token: string }>('/api/csrf-refresh')
        csrfToken.value = response.token
    } catch (error) {
        console.error('Failed to fetch CSRF token:', error)
        // Token remains undefined — subsequent requests will either show error or retry
    }
})
